module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error500"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/error-image.png"),
      "alt": _vm.$config.WEBSITE_NAME + 'Error 500 Page',
      "srcset": (_vm.img1 + " 1x, " + _vm.img2 + " 2x")
    }
  })])]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4 col-sm-offset-2 text-center"
  }, [_c('h1', {
    staticClass: "error500__heading"
  }, [_c('span', {
    staticClass: "error500__title"
  }, [_vm._v("500")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "error500__lead"
  }, [_vm._v("Server Error")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "error500__text"
  }, [_vm._v("เกิดข้อผิดพลาดกับระบบลองใหม่นะคะ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 col-sm-offset-4"
  }, [_c('a', {
    staticClass: "btn btn--white",
    attrs: {
      "href": "/"
    }
  }, [_vm._v("กลับไปหน้าแรก")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0d1298c8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d1298c8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/500.vue
// module id = 718
// module chunks = 1